<div class="knowledge-body-title">
  <div class="knowledge-body-title-text">
    <ng-content select="[title]"> </ng-content>
  </div>
  <div class="knowledge-body-title-jit" *ngIf="isShowUpdatedAtJIT">
    <ng-content select="[jit]"> </ng-content>
  </div>
</div>
